import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { redirectToSso } from '@/platform/auth/session/sso'
import { FullPageLoader } from '@/shared/ui/FullPageLoader'
import { useAppDispatch, useAppSelector } from '@/app/store/hooks'
import { authActions } from '../model/authSlice'
import { StateMessage } from '@/shared/ui/StateMessage'

export function AuthGuard() {
  const status = useAppSelector((state) => state.auth.status)
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (status === 'anonymous') redirectToSso()
  }, [status])

  if (status === 'error') return <StateMessage title="Chưa kết nối được" actionLabel="Thử lại" onAction={() => dispatch(authActions.checking())} />
  if (status === 'expired') return <StateMessage title="Vui lòng đăng nhập lại" actionLabel="Đăng nhập" onAction={() => redirectToSso()} />
  return status === 'authenticated' ? <Outlet /> : <FullPageLoader />
}
